import DestinationRoutes from "./destination";

export default [
    ...DestinationRoutes
]
